module.exports = __webpack_public_path__ + "img/bg03.b266c8f6.png";